module.exports = __webpack_public_path__ + "static/img/14000678.b8779c59.png";